$(function() {
    jQuery.event.special.touchstart = {
        setup: function( _, ns, handle ){
            this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
        }
    };
    jQuery.event.special.touchmove = {
        setup: function( _, ns, handle ){
            this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
        }
    };
    jQuery.event.special.mousewheel = {
        setup: function( _, ns, handle ){
            this.addEventListener("mousewheel", handle, { passive: !ns.includes("noPreventDefault") });
        }
    };
    jQuery.event.special.wheel = {
        setup: function( _, ns, handle ){
            this.addEventListener("wheel", handle, { passive: !ns.includes("noPreventDefault") });
        }
    };
});

// Verifica o tamanho da tela
function identifyScreen()
{
    var screen = $(window).innerWidth();
    var body = $('body');

    var datascreen = ('xs');

    if (screen >= 768) {
        datascreen = ('sm');
    }

    if (screen >= 992) {
        datascreen = ('md');
    }

    if (screen >= 1200) {
        datascreen = ('lg');
    }

    if (screen >= 1400) {
        datascreen = ('xl');
    }

    body.attr('data-screen', datascreen);

    return datascreen;
}

var pageName = '';
function identifyPage(){
    var body = $('body');
    if (body.data('page')) {
        pageName = $('body').data('page');
    }
}

var dataScreen;
$(document).ready(function(){
    dataScreen = $('body').data('screen');
    identifyScreen();
});

$(window).resize(function(){
    identifyScreen();
});



